import axios from "axios";
import * as AppSettingsService from "./AppSettingsService";
import { IOrgAttributes } from "../types/OrganizationTypes";
const appSettings = AppSettingsService;

export async function getAttributesByOrgId(orgId: number): Promise<IOrgAttributes[]> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/GetWandaAttributesByOrgId?organizationId=${orgId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
